import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid, LinearProgress, makeStyles, Paper } from "@material-ui/core";
import { Typography } from "@totalsoft/rocket-webapp-components-deprecated";
import { emptyArray } from "constants/defaultValues";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { getTenant } from "providers/TenantProvider";
import { GET_QUOTE_PARTNERS } from "features/client/queries";
import quotePageStyle from "../styles";
import { countryCodeConstants } from "features/common/constants";

const useStyles = makeStyles(quotePageStyle);

function QuoteHeaderPartners({ quoteId, clientName }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { countryCode } = getTenant();
  const colesseeFunctionality = countryCode === countryCodeConstants.china;

  const quoteExists = Boolean(quoteId);

  const { data, loading } = useQueryWithErrorHandling(GET_QUOTE_PARTNERS, {
    skip: !quoteExists || !colesseeFunctionality,
    variables: { quoteId },
  });
  const partners = data?.getQuotePartners || emptyArray;

  return (
    <Paper variant="outlined" className={classes.paperDialog}>
      <Grid item xs>
        <Typography className={classes.gridItemWizard}>{clientName}</Typography>
        {colesseeFunctionality && <Typography className={classes.labelWizard}>: {t("Client.Role_Client")}</Typography>}
      </Grid>
      {loading ? (
        <LinearProgress />
      ) : (
        partners.map((p) => (
          <Grid item xs key={p.id}>
            <Typography className={classes.gridItemWizard}>{p.partnerName}</Typography>
            <Typography className={classes.labelWizard}>: {p.roleName}</Typography>
          </Grid>
        ))
      )}
    </Paper>
  );
}

QuoteHeaderPartners.propTypes = {
  quoteId: PropTypes.number,
  clientName: PropTypes.string.isRequired,
};

export default QuoteHeaderPartners;
